// Enum values match backend `feature.key` slugs (see migration
// AddFeatureTableAndLastSeenFeature1777138423286). The frontend uses slugs as
// the source of truth for which AppTour steps reference a tracked feature; the
// numeric id ordering comes from the backend via /user-data/get-unseen-features.
export enum ApptourFeature {
  AUTO_TEMPO_ADJUSTMENT = 'auto_tempo_adjustment',
}

// Mirrors the backend `Feature` entity row (id + key) — the only fields the
// frontend cares about for selecting and ordering walkthrough steps.
export interface ApptourFeatureItem {
  id: number;
  key: string;
}
